<template>
  <div class="managePublicVue" style="margin-bottom: 10px;padding-bottom: 10px;">
       <div class="c-common-space jobs-gridview c-responsive-fixwidth o-overflow-visible">
            <div class="row">
                <div class="col-md-12">
                   <div class="grids c-common-box-shadow c-radius3 c-bg-white o-public-box-height">
                        <!-- head -->
                        <div class="head">
                            <div class="title">

                               <div class="custom-col text-left">
                                    <div class="o-viewBy">
                                        <label class="o-blue-regular-text">View by:</label>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="type" value="job-future" v-model="show_type">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> <!-- Job Info --> Calendar Future
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="type" value="job-past" v-model="show_type">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> <!-- Job Info --> Calendar Past
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="type" value="call" v-model="show_type">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> Call Assignment
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="type" value="employeeCSV" v-model="show_type">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> <!-- Employee CSV Configuration -->Job CSV Export
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="type" value="settings" v-model="show_type">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> Settings
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /head -->
                    </div>
                </div>
            </div>
        </div>

        <div  v-loading="loading" class="c-common-space jobs-gridview c-responsive-fixwidth o-overflow-visible">
            <div class="row">
                <div class="col-md-12">
                    <!-- <h3 class="o-margin-bottom10">Rearrange the order by draging the fields</h3> -->
                </div>
            </div>

            <div class="c-common-space jobs-gridview o-overflow-visible" v-show="show_type == 'job-future'">
                <div class="row">
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-public-box-height">
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Check the limit what items of information are displayed on Calendar page:</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">

                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box-large">
                                   <drag :transfer-data="{element:job.element, type:'job' , string:job.string}"  v-for="job in job_all_future" :key="job.id">
                                     <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table">
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p><a href="javascript: void(0)">{{job.string}}</a></p>
                                                </div>

                                            </div>
                                        </div>
                                       </div>
                                   </drag>

                                </div>
                            </div>
                            <!-- /body -->
                        </div>
                    </div>
                    <!-- /single grid -->
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-overflow-visible">
                            <!-- head -->
                            <div class="head">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h3 class="o-super-title">Add Calendar info to your list</h3>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <div class="o-viewBy">
                                            <div class="radio">
                                                <label>
                                                    <input type="radio" @change="onChangePastFutureType(future_job_type)" name="calender-job-future" value="my-crew" v-model="future_job_type">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>My Crew
                                                </label>
                                            </div>

                                            <div class="radio">
                                                <label>
                                                    <input type="radio" @change="onChangePastFutureType(future_job_type)" name="calender-job-future" value="my-job" v-model="future_job_type">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>My Job
                                                </label>
                                            </div>
                                            <div class="radio">
                                                <label>
                                                    <input type="radio" @change="onChangePastFutureType(future_job_type)" name="calender-job-future" value="all-job" v-model="future_job_type">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span> All Job
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">
                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box2">

                                    <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10" v-for="(info,infoIdx) in job_info_future" :key="infoIdx">
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p>{{getElementName(info)}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="schedule-box-right">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p class="o-wishlist-delete"><a href="javascript: void(0)" @click="deleteJobInfoFuture(info)"><i class="fa fa-trash" aria-hidden="true"></i></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                            <!-- /body -->
                            <!-- bottom -->
                            <drop @drop="handleDragover('job-future',...arguments)" @dragover="highlightWishMethod()" @dragleave="removeHightlight()">
                              <div v-loading="calenderLoad" :class="{'o-wishlist-drag-area':true, 'bottom':true, 'highlight':hightlightWish } ">
                                  <div class="o-wislist-drop o-wislist-drop--large">
                                      <div class="o-wislist-drop-note">
                                          <i class="fa fa-files-o" aria-hidden="true"></i><br />
                                          Drag and drop
                                      </div>
                                  </div>
                              </div>
                            </drop>
                            <!-- /bottom -->
                        </div>
                    </div>
                    <!-- /single grid -->
                </div>
            </div>

            <div class="c-common-space jobs-gridview o-overflow-visible" v-show="show_type == 'job-past'">
                <div class="row">
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-public-box-height">
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Check the limit what items of information are displayed on Calendar page:</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">

                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box-large">
                                   <drag :transfer-data="{element:job.element, type:'job' , string:job.string}"  v-for="job in job_all_past" :key="job.id">
                                     <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table">
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p><a href="javascript: void(0)">{{job.string}}</a></p>
                                                </div>

                                            </div>
                                        </div>
                                       </div>
                                   </drag>

                                </div>
                            </div>
                            <!-- /body -->
                        </div>
                    </div>
                    <!-- /single grid -->
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-overflow-visible">
                            <!-- head -->
                            <div class="head">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h3 class="o-super-title">Add Calendar info to your list</h3>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <div class="o-viewBy">
                                            <div class="radio">
                                                <label>
                                                    <input type="radio" @change="onChangePastFutureType(past_job_type)" name="calender-job-past" value="my-crew" v-model="past_job_type">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>My Crew
                                                </label>
                                            </div>
                                            <div class="radio">
                                                <label>
                                                    <input type="radio" @change="onChangePastFutureType(past_job_type)" name="calender-job-past" value="my-job" v-model="past_job_type">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>My Job
                                                </label>
                                            </div>
                                            <div class="radio">
                                                <label>
                                                    <input type="radio" @change="onChangePastFutureType(past_job_type)" name="calender-job-past" value="all-job" v-model="past_job_type">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span> All Job
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">
                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box2">

                                    <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10" v-for="(info,infoIndex) in job_info_past" :key="infoIndex">
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p>{{getElementName(info)}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="schedule-box-right">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p class="o-wishlist-delete"><a href="javascript: void(0)" @click="deleteJobInfoPast(info)"><i class="fa fa-trash" aria-hidden="true"></i></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                            <!-- /body -->
                            <!-- bottom -->
                            <drop @drop="handleDragover('job-past',...arguments)" @dragover="highlightWishMethod()" @dragleave="removeHightlight()">
                              <div v-loading="calenderLoad" :class="{'o-wishlist-drag-area':true, 'bottom':true, 'highlight':hightlightWish } ">
                                  <div class="o-wislist-drop o-wislist-drop--large">
                                      <div class="o-wislist-drop-note">
                                          <i class="fa fa-files-o" aria-hidden="true"></i><br />
                                          Drag and drop
                                      </div>
                                  </div>
                              </div>
                            </drop>
                            <!-- /bottom -->
                        </div>
                    </div>
                    <!-- /single grid -->
                </div>
            </div>

            <div class="c-common-space jobs-gridview o-overflow-visible" v-show="show_type == 'call'">
                <div class="row">

                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-public-box-height">
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Check the limit what items of information are displayed on Call Assignment page:</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">
                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box-large">
                                  <drag :transfer-data="{element:call.element, type:'call' , string:call.string}" v-for="call in call_all" :key="call.id">
                                    <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table" >
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p><a href="javascript: void(0)" >{{call.string}}</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  </drag>
                                </div>
                            </div>
                            <!-- /body -->
                        </div>
                    </div>
                    <!-- /single grid -->
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-overflow-visible" >
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Add Call Assignment info to your list</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">
                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box2">

                                    <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10" v-for="(info,infoKey) in call_assignment" :key="infoKey">
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p>{{getCallName(info)}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="schedule-box-right">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p class="o-wishlist-delete"><a href="javascript: void(0)" @click="deleteCallInfo(info)"><i class="fa fa-trash" aria-hidden="true"></i></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- /body -->
                            <!-- bottom -->
                          <drop @drop="handleDragover('call',...arguments)" @dragover="highlightCallWishMethod()" @dragleave="removeHightlightCall()">
                            <div v-loading="callLoad" :class="{'o-wishlist-drag-area':true, 'bottom':true, 'highlight':hightlightCallWish } ">
                                <div class="o-wislist-drop o-wislist-drop--large">
                                    <div class="o-wislist-drop-note">
                                        <i class="fa fa-files-o" aria-hidden="true"></i><br />
                                        Drag and drop
                                    </div>
                                </div>
                            </div>
                          </drop>
                            <!-- /bottom -->
                        </div>
                    </div>
                    <!-- /single grid -->

                </div>
            </div>

            <div class="c-common-space jobs-gridview o-overflow-visible" v-show="show_type == 'employeeCSV'">
                <div class="row">

                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-public-box-height">
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Employee CSV configuration:</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">
                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box-large">
                                  <drag :transfer-data="{element:call.element, type:'employee' , string:call.string}" v-for="call in employee_all" :key="call.id">
                                    <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table" >
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p><a href="javascript: void(0)">{{call.string}}</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  </drag>
                                </div>
                            </div>
                            <!-- /body -->
                        </div>
                    </div>
                    <!-- /single grid -->
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-overflow-visible" >
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Add employee info to your list</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">
                                <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box2">

                                    <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10" v-for="(info, empIndex) in employee_details" :key="empIndex">
                                        <div class="schedule-box-left">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p>{{getEmployeeElement(info)}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="schedule-box-right">
                                            <div class="skill-details">
                                                <div class="schedule-details-box">
                                                    <p class="o-wishlist-delete"><a href="javascript: void(0)" @click="deleteEmployeeInfo(info)"><i class="fa fa-trash" aria-hidden="true"></i></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- /body -->
                            <!-- bottom -->
                          <drop @drop="handleDragover('employee',...arguments)" @dragover="highlightCSVWishMethod()" @dragleave="removeHightlightCSV()">
                            <div v-loading="CSVLoad" :class="{'o-wishlist-drag-area':true, 'bottom':true, 'highlight':hightlightCSVWish } ">
                                <div class="o-wislist-drop o-wislist-drop--large">
                                    <div class="o-wislist-drop-note">
                                        <i class="fa fa-files-o" aria-hidden="true"></i><br />
                                        Drag and drop
                                    </div>
                                </div>
                            </div>
                          </drop>
                            <!-- /bottom -->
                        </div>
                    </div>
                    <!-- /single grid -->

                </div>
            </div>

            <div class="c-common-space jobs-gridview o-overflow-visible" v-show="show_type == 'settings'">
                <div class="row">

                    <!-- single grid -->
                    <div class="col-sm-12 col-md-12">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-public-box-height">
                            <!-- head -->
                            <div class="head">
                                <div class="">
                                    <h3 class="o-super-title">Notes and Documents settings:</h3>
                                </div>
                            </div>
                            <!-- /head -->
                            <!-- body -->
                            <div class="body">                               
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px;">
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <div class="clearfix">    
                                                <div class="form-group-left">
                                                    <label>View Confirm:</label>
                                                </div> 
                                                <div class="radio o-custom-radio">
                                                    <label>Yes
                                                    <input @change="notesAndDocumentChange()" type="radio" name="o5" v-model="notes_Document" value="enabled"> 
                                                        <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                    </label>
                                                </div> 
                                                <div class="radio o-custom-radio">
                                                <label>No
                                                <input @change="notesAndDocumentChange()" type="radio" v-model="notes_Document" name="o5" value="disabled"> 
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="col-md-12 common-margin-bottom20">
                                        <p class="ps2 o-margin-top5">* If disable, users can not able to see the notes and documents section.</p>
                                    </div>
                                </div>
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <h3 class="o-super-title">Currency Settings:</h3>
                                            <div class="clearfix">    
                                                <div class="form-group-left">
                                                    <label>Select Currency:</label>
                                                </div> 
                                                <div class="radio o-custom-radio">
                                                    <label>USD($)
                                                    <input @change="currencySettingsChange()" type="radio" name="ao5" v-model="currency" value="usd"> 
                                                        <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                    </label>
                                                </div> 
                                                <div class="radio o-custom-radio">
                                                <label>Pound(<span>&#163;</span>)
                                                <input @change="currencySettingsChange()" type="radio" v-model="currency" name="ao5" value="pound"> 
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <h3 class="o-super-title">Chat Widget Tags:</h3>
                                            <div class="clearfix">    
                                                <div class="form-group-left">
                                                    <label>Enter tags:</label>
                                                </div> 
                                                <input-tag v-model="tags" :before-adding="saveTags()" :add-tag-on-blur="true" placeholder="Enter your tag and press enter"></input-tag>
                                                <!-- {{tags}} -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <h3 class="o-super-title">Sign In Sheet Template File(.rdlx-json):</h3>
                                            <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{new_files[0].selected?'Change Files':'Add New Files'}}</button>
                                                <input type="file" @change="addFileForAddNewJob($event,0)" />
                                                <button @click="uploadService()" v-if="new_files[0].selected" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i>Upload</button>
                                                <a :href="gcs_signin_sheet_template" v-if="gcs_signin_sheet_template" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-download" aria-hidden="true"></i>Download</a>
                                                <span class="addJobTypeArea">
                                                    <span class="addJob-title">{{snippet(new_files[0].name)}}</span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <h3 class="o-super-title">Sign in sheet data source link:</h3>
                                            <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                <!-- <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-download" aria-hidden="true"></i>Generate Link</button> -->
                                                <!-- link-generate-style -->
                                                <input type="text" v-model="gcs_signin_sheet_data" class="form-control">
                                            </label>
                                        </div>
                                    </div>
                                </div> 
                                
                                
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">

                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <div class="clearfix">    
                                                <div class="">
                                                    <label class="o-super-title">Private Skill Memcache Enable:</label>
                                                </div> 

                                                <el-switch
                                                    style="display: inline"
                                                    v-model="privateSkillMemcacheEnable"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="switchPrivateSkillMemcacheEnable"
                                                    >
                                                </el-switch>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">

                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <div class="clearfix">    
                                                <div class="form-group-left">
                                                    <label>Independent Support Link:</label>
                                                </div> 

                                                <el-switch
                                                    style="display: inline"
                                                    v-model="supportLinkSwitch"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="switchSupportLink"
                                                    >
                                                </el-switch>
                                                
                                            </div>

                                            <div v-if="supportLinkSwitch">
                                                <div class="row">
                                                    <div class="col-12 col-md-8">
                                                        <h3 class="o-super-title">Save Support Link:</h3>
                                                        <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                            <input type="text" v-model="supportSiteUrl" class="form-control">
                                                        </label>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <label class="mrt-25 common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                            <button @click="saveSupportLink()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange">Save</button>
                                                            
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <h3 class="o-super-title">Estimate Payroll Template File(.rdlx-json):</h3>
                                            <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{payroll_files[0].selected?'Change Template':'Add Estimate Payroll Template'}}</button>
                                                <input type="file" @change="addFileForEstimatePayroll($event,0)" />
                                                <button @click="uploadPayrollEstimate()" v-if="payroll_files[0].selected" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i>Upload</button>
                                                <a :href="gcs_estimate_payroll_template" v-if="gcs_estimate_payroll_template" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-download" aria-hidden="true"></i>Download</a>
                                                <span class="addJobTypeArea">
                                                    <span class="addJob-title">{{snippet(payroll_files[0].name)}}</span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="row" style="border-bottom: 1px solid gainsboro; margin-bottom: 10px; padding-bottom: 10px;">
                                    <!-- <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <h3 class="o-super-title">Payroll Estimate data source link:</h3>
                                            <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                
                                                <input type="text" v-model="payroll_estimate_sheet_data" class="form-control">
                                            </label>
                                        </div>
                                    </div> -->

                                    <!-- <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-download" aria-hidden="true"></i>Generate Link</button> -->
                                                <!-- link-generate-style -->

                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <div class="clearfix">    
                                                <div class="form-group-left">
                                                    <label>View Estimate Button:</label>
                                                </div> 

                                                <el-switch
                                                    style="display: inline"
                                                    v-model="estimate_payroll_button"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="changePayrollEstimate"
                                                    >
                                                </el-switch>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="margin-bottom: 10px;">    
                                    <div class="col-md-12">
                                        <div class="form-group o-no-margin-bottom">
                                            <div class="clearfix">    
                                                <div class="form-group-left">
                                                    <label>IATSE Email List:</label>
                                                </div> 

                                                <el-switch
                                                    style="display: inline"
                                                    v-model="mailing_list_visibility_flag"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="changeMailListVisibility"
                                                    >
                                                </el-switch>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /body -->
                        </div>
                    </div>
                    <!-- /single grid -->
                </div>
            </div>
        </div>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import InputTag from 'vue-input-tag'
    export default {
        components:{
            InputTag
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                selectedClientId: 'selectedClientId',
                userRole: 'userRole'
            })
        },
        data() {
            return {
                // past_job_type:'my-job',
                // future_job_type:'my-job',
                tags_length: 0,
                loading: false,
                past_job_type:'',
                future_job_type:'',
                gcs_signin_sheet_template: null,
                gcs_estimate_payroll_template: null,
                gcs_signin_sheet_data:'',
                payroll_estimate_sheet_data:'',
                estimate_payroll_button:false,
                job_info_past: [],
                job_info_future: [],
                call_assignment: [],
                notes_Document:'disabled',
                hightlightWish: false,
                job_all_past: [],
                job_all_future: [],
                call_all: [],
                show_type: 'job-future',
                employee_details: [],
                employee_all: [],
                calenderLoad: false,
                hightlightWish:false,
                callLoad:false,
                hightlightCallWish:false,
                CSVLoad:false,
                hightlightCSVWish:false,
                currency:'usd',
                tags:[],
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
                payroll_files: [
                    {
                        'name': 'No file chosen',
                        'selected': false
                    }
                ],
                isFirst:true,
                job_temp: [
                    {
                        'element': 'employee_name',
                        'string': 'Name of employee'
                    },
                    {
                        'element': 'call_times',
                        'string': 'Call Times'
                    },
                    {
                        'element': 'position',
                        'string': 'Position'
                    },
                    {
                        'element': 'call_status',
                        'string': 'Call Status'
                    },
                    {
                        'element': 'confirmed_by',
                        'string': 'Confirmed By'
                    },
                    {
                        'element': 'sms_sent',
                        'string': 'SMS Sent(Timestamp)'
                    },
                    {
                        'element': 'seniority',
                        'string': 'Seniority'
                    },
                    // {
                    //     'element': 'shift_count',
                    //     'string': 'Shift Count'
                    // },
                    // {
                    //     'element': 'seniority+shift_count',
                    //     'string': 'Seniority+Shift Count'
                    // },
                    {
                        'element': 'notes',
                        'string': 'Notes'
                    }
                ],
                call_temp: [],
                emp_temp:[
                    {
                        'element': 'name',
                        'string': 'Name'
                    },
                    {
                        'element': 'position',
                        'string': 'Skill'
                    },
                    {
                        'element': 'seniority',
                        'string': 'Seniority'
                    },
                    {
                        'element': 'status',
                        'string': 'Status'
                    },
                    {
                        'element': 'called_at',
                        'string': 'Called at'
                    },
                    {
                        'element': 'time_in',
                        'string': 'Time In'
                    },
                    {
                        'element': 'time_out',
                        'string': 'Time Out'
                    },
                    {
                        'element': 'phone',
                        'string': 'Phone'
                    },
                    {
                        'element': 'address',
                        'string': 'Address'
                    },
                    {
                        'element': 'call_notes',
                        'string': 'Call Notes'
                    },
                    {
                        'element': 'email',
                        'string': 'Email'
                    },
                    {
                        'element': 'job_name',
                        'string': 'Job Name'
                    },
                    {
                        'element': 'job_number',
                        'string': 'Job Number'
                    },
                    {
                        'element': 'job_venue',
                        'string': 'Venue'
                    },
                    {
                        'element': 'employer',
                        'string': 'Employer'
                    },
                    {
                        'element': 'employer_contact',
                        'string': 'Employer Contact'
                    },
                    {
                        'element': 'rate',
                        'string': 'Rate'
                    }
                ],
                mailing_list_visibility_flag: 0,
                supportLinkSwitch: 0,
                supportSiteUrl: '',
                privateSkillMemcacheEnable: false
            }
        },
        methods: {
            changeMailListVisibility() {
                this.loading = true;
                console.log(this.mailing_list_visibility_flag);
                // let result = this.mailing_list_visibility_flag ? 'subscribe' : 'unsubscribe';/
                service.post('client/'+this.selectedClientId+'/mailingListVisibility',{
                    mailing_list_visibility_flag: this.mailing_list_visibility_flag
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId':  this.selectedClientId
                }).then((res) => {
                    // this.payroll_files[0].path = res.data.result.path;
                    // this.payroll_files[0].uploaded = true;
                    this.loading = false;
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        message: res.data.status_message
                    });
                    this.getSettings();
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: 'Error',
                        message: 'Something went wrong.'
                    });
                });
            },

            addFileForAddNewJob(e, index) {
                var input = e.target;
                //console.log(input.files);
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                        
                        //console.log( this.new_files, index);
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },

            addFileForEstimatePayroll(e, index) {
                var input = e.target;
                //console.log(input.files);
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.payroll_files[index].img = img
                            this.payroll_files[index].name = input.files[0].name,
                            this.payroll_files[index].status = true; 
                            this.payroll_files[index].uploading = false;
                            this.payroll_files[index].uploaded = false;
                            this.payroll_files[index].path = '';
                            this.payroll_files[index].label = 'Report';
                            this.payroll_files[index].type = type[0];
                            this.payroll_files[index].fileExtension = this.setPicture(type[0]);
                            this.payroll_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                        
                        //console.log( this.payroll_files, index);
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },

            uploadPayrollEstimate() {
                // console.log("uploadPayrollEstimate")
                this.loading = true;
                service.post('client/uploadPayrollTemplate', {
                    'image_file': this.payroll_files[0].img,
                    'file_name': this.payroll_files[0].name,
                    'client_id': this.selectedClientId
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId':  this.selectedClientId
                }).then((res) => {
                    // this.payroll_files[0].path = res.data.result.path;
                    // this.payroll_files[0].uploaded = true;
                    this.loading = false;
                    this.payroll_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        message: 'File saved successfully.'
                    });
                    this.getSettings();
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: 'Error',
                        message: 'Something went wrong.'
                    });
                });
            },
            snippet(value) {
                if (value.length > 25)
                    return value.slice(0, 25) + '  ...';
                else
                    return value;
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            uploadService() {
                this.loading = true;
                service.post('client/uploadTemplate', {
                    'image_file': this.new_files[0].img,
                    'file_name': this.new_files[0].name,
                    'client_id': this.selectedClientId
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                }).then((res) => {
                    // this.new_files[0].path = res.data.result.path;
                    // this.new_files[0].uploaded = true;
                    this.loading = false;
                    this.new_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        message: 'File saved successfully.'
                    });
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: 'Error',
                        message: 'Something went wrong.'
                    });
                });
            },
            saveTags(){
                // console.log('tags saved', this.tags);
                if(!this.isFirst && this.show_type=='settings' && (this.tags && (this.tags.length || this.tags.length ==0) && this.tags_length != this.tags.length)){
                    service.post('client/' + this.selectedClientId + "/saveClientSettings",{'widget_tags': JSON.stringify(this.tags)}, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId,
                        'cs3-context-role': this.userRole
                    }).then((client) => {
                        this.tags_length = this.tags.length;
                        // this.getSettings();
                    }).catch((err) => {
                        console.log(err);
                    });
                }
                this.isFirst = false;
            },
            onChangePastFutureType(type){
                service.post('client/' + this.selectedClientId + "/jobTypeSettings", {
                    'job_type': this.show_type,
                    'access_type': type
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.selectedClientId
                })
                .then((client) => {
                    // console.log(client);
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleDragover(type, data, event) {
                if (type == 'job-future') {
                    this.calenderLoad = true;
                    this.hightlightWish = true;
                    service.post('client/' + this.selectedClientId + "/jobInfoSettingsFuture", {
                        'element': data.element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    this.calenderLoad = false;
                    this.hightlightWish = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                } else if (type == 'job-past') {
                    this.calenderLoad = true;
                    this.hightlightWish = true;
                    service.post('client/' + this.selectedClientId + "/jobInfoSettingsPast", {
                        'element': data.element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    this.calenderLoad = false;
                    this.hightlightWish = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                }else if (type == 'call') {
                    this.callLoad = true;
                    this.hightlightCallWish = true;
                    service.post('client/' + this.selectedClientId + "/callAssignInfoSettings", {
                        'element': data.element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    this.callLoad = false;
                    this.hightlightCallWish = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    this.CSVLoad = true;
                    this.hightlightCSVWish = true;
                    service.post('client/' + this.selectedClientId + "/addToEmployeeSettings", {
                        'element': data.element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    this.CSVLoad = false;
                    this.hightlightCSVWish = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            highlightWishMethod() {
                this.hightlightWish = true;
            },
            removeHightlight() {
                this.hightlightWish = false;
            },
            highlightCallWishMethod() {
                this.hightlightCallWish = true;
            },
            removeHightlightCall() {
                this.hightlightCallWish = false;
            },
             highlightCSVWishMethod() {
                this.hightlightCSVWish = true;
            },
            removeHightlightCSV() {
                this.hightlightCSVWish = false;
            },
            getElementName(element) {
                if (element == 'employee_name')
                    return "Name of Employee";
                else if (element == 'call_times')
                    return "Call times";
                else if (element == "position")
                    return "Position";
                else if (element == "call_status")
                    return "Call Status";
                else if (element == "confirmed_by")
                    return "Confirmed By";
                else if (element == "sms_sent")
                    return "SMS Sent(Timestamp)";
                else if (element == "seniority")
                    return "Seniority";
                else if (element == "shift_count")
                    return "Shift Count";
                else if (element == "seniority+shift_count")
                    return "Seniority+Shift Count";
                else if (element == "notes")
                    return "Notes";
                else {
                    return element;
                }

            },
            getCallName(info) {
                for (var i = 0; i < this.call_temp.length; i++) {
                    if (this.call_temp[i].element == info)
                        return this.call_temp[i].string;
                }
            },
            getSettings() {
                service.get('client/' + this.selectedClientId, {
                        'Authorization': this.userToken
                    })
                    .then((client) => {
                        this.mailing_list_visibility_flag = client.data.result.mailing_list_visibility_flag;
                        this.currency=client.data.result.currency;
                        this.gcs_signin_sheet_template=client.data.result.gcs_signin_sheet_template;
                        this.gcs_signin_sheet_data=client.data.result.gcs_signin_sheet_data;
                        // this.gcs_estimate_payroll_template=client.data.result.payroll_active_arjs.gcs_template;
                        // this.payroll_estimate_sheet_data=client.data.result.payroll_active_arjs.json_payload_url;
                        this.estimate_payroll_button=client.data.result.estimate_payroll_button;
                        this.job_info_past = client.data.result.settings['job-info-config-past'];
                        this.job_info_future = client.data.result.settings['job-info-config-future'];
                        this.call_assignment = client.data.result.settings['call-assignment-config'];
                        this.past_job_type=client.data.result.settings['job-type-past'][0];
                        this.future_job_type=client.data.result.settings['job-type-future'][0];
                        this.employee_details = JSON.parse(client.data.result.employee_settings);
                        this.tags=JSON.parse(client.data.result.widget_tags);
                        this.tags_length = this.tags && this.tags.length ? this.tags.length : 0;
                        this.supportLinkSwitch = client.data.result.support_site_url && client.data.result.support_site_url != '' ? 1 : 0;
                        this.supportSiteUrl = client.data.result.support_site_url ? client.data.result.support_site_url : '';
                        this.privateSkillMemcacheEnable = client.data.result.private_skill_memcache_enable ? 1 : 0;
                        //  console.log(this.employee_details);
                        this.notes_Document=client.data.result.settings['notes-documents-config'];
                        var i = 0;
                        this.job_all_past = [];


                        for (i = 0; i < this.job_temp.length; i++) {

                            if (Object.values(this.job_info_past).indexOf(this.job_temp[i].element) == -1) {

                                this.job_all_past.push(this.job_temp[i]);
                            }

                        }
                        this.job_all_future = [];

                        for (i = 0; i < this.job_temp.length; i++) {

                            if (Object.values(this.job_info_future).indexOf(this.job_temp[i].element) == -1) {

                                this.job_all_future.push(this.job_temp[i]);
                            }

                        }

                        this.call_all = [];
                        for (i = 0; i < this.call_temp.length; i++) {

                            if (Object.values(this.call_assignment).indexOf(this.call_temp[i].element) == -1) {

                                this.call_all.push(this.call_temp[i]);
                            }

                        }
                        this.employee_all = [];
                        if (this.employee_details == null) {
                            this.employee_all = this.emp_temp;
                        } else {
                            for (i = 0; i < this.emp_temp.length; i++) {


                                if (this.employee_details.indexOf(this.emp_temp[i].element) == -1) {

                                    this.employee_all.push(this.emp_temp[i]);
                                }

                            }

                        }

                        //  console.log(this.employee_all);


                    }).catch((err) => {
                        console.log(err);
                    });
            },

            deleteJobInfoPast(element) {
                service.post('client/' + this.selectedClientId + "/deleteFromJobInfoSettingsPast", {
                        'element': element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            deleteJobInfoFuture(element) {
                service.post('client/' + this.selectedClientId + "/deleteFromJobInfoSettingsFuture", {
                        'element': element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            deleteCallInfo(element) {
                service.post('client/' + this.selectedClientId + "/deleteFromCallAssignInfoSettings", {
                        'element': element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            getEmployeeElement(info) {
                for (var i = 0; i < this.emp_temp.length; i++) {
                    if (this.emp_temp[i].element == info)
                        return this.emp_temp[i].string;
                }
            },
            deleteEmployeeInfo(element) {
                service.post('client/' + this.selectedClientId + "/deleteFromEmployeeSettings", {
                        'element': element
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        //console.log(client);
                        this.getSettings();
                    }).catch((err) => {
                        console.log(err);
                    });
                //console.log(element);
            },
            notesAndDocumentChange(){
                service.post('client/' + this.selectedClientId + "/notesAndDocumentsSettings",{'element': this.notes_Document}, {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.selectedClientId,
                    'cs3-context-role': this.userRole
                })
                .then((client) => {
                    this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },
            currencySettingsChange(){
                service.post('client/' + this.selectedClientId + "/currencySettings",{'currency': this.currency}, {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.selectedClientId,
                    'cs3-context-role': this.userRole
                })
                .then((client) => {
                    this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },
            getcallAssignInfo(){    
                service.get('client/getcallAssignInfo', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole
                })
                .then((res) => {
                    this.call_temp=res.data.result;
                    //console.log(res.data.result);
                    this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });    
            },
            changePayrollEstimate(){
                // console.log("changePayrollEstimate");
                // console.log(this.estimate_payroll_button);

                 service.post('client/' + this.selectedClientId + "/payrollButtonSettings",{'estimate_payroll_button': this.estimate_payroll_button}, {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.selectedClientId,
                    'cs3-context-role': this.userRole
                })
                .then((client) => {
                    this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },
            switchPrivateSkillMemcacheEnable() {
                this.loading = true;
                service.post('client/' + this.selectedClientId + "/savePrivateSkillMemcacheEnable",{ private_skill_memcache_enable: this.privateSkillMemcacheEnable }, {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.selectedClientId,
                    'cs3-context-role': this.userRole
                }).then((client) => {
                    this.loading = false;                    
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        message: 'Updated Successfully'
                    });
                    this.getSettings();
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
            },
            switchSupportLink() {
                if(this.supportLinkSwitch == 0) {
                    this.supportSiteUrl= '';
                    this.saveSupportLink();
                }
            },
            saveSupportLink(){
                // console.log('tags saved', this.tags);    
                // if(this.supportLinkSwitch == 0) {
                //     this.supportSiteUrl = '';
                // }  
                this.loading = true;
                service.post('client/' + this.selectedClientId + "/saveClientSupportSiteUrl",{ support_site_url: this.supportSiteUrl }, {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.selectedClientId,
                    'cs3-context-role': this.userRole
                }).then((client) => {
                    this.loading = false;                    
                    if(this.supportSiteUrl != '') {
                        this.supportLinkSwitch = 1;
                    }else {
                        this.supportLinkSwitch = 0;
                    }
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        message: 'Updated Successfully'
                    });
                    // this.getSettings();
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
            },
        },
        beforeMount(){
            this.getcallAssignInfo();
        }
    }

</script>

<style scoped>
.mrt-25 {
    margin-top: 25px;
}
.text-right{
    text-align: right;
}
.link-generate-style{
    width: 80%;
    display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/managePublic.vue